import { QueryKey } from 'query';

export const PERFORMANCE = 'performance';
const METRICS = 'metrics';
const COLUMNS = 'columns';
const FILTERS = 'filters';
const DIMENSIONS = 'dimensions';
const PRESETS = 'presets';

export const businessKey = new QueryKey(PERFORMANCE);

export const chart = businessKey.chart();
export const grid = businessKey.grid();
export const grids = businessKey.grids();
export const metrics = businessKey.all(METRICS);
export const columns = businessKey.all(COLUMNS);
export const dimensions = businessKey.all(DIMENSIONS);
export const filters = businessKey.exact(FILTERS);
export const presets = businessKey.all(PRESETS);
